import { defineStore } from "pinia";

const payments = [
  {
    id: 1,
    paymentNo: "PAY-2026-0011",
    invoiceNo: "INV-2026-0001",
    paymentDate: "2026-03-29",
    residentName: "สมชาย ใจดี",
    unitCode: "A-101",
    building: "อาคาร A",
    amount: 1800,
    method: "bank_transfer",
    status: "completed",
    receiptNo: "RC-2026-0011",
    recordedBy: "Finance 01",
    referenceNo: "TXN-99881231",
    bankName: "KBank",
    verifiedBy: "Finance Supervisor",
    verifiedAt: "2026-03-29 14:30",
    note: "ชำระเต็มจำนวนตามกำหนด",
  },
  {
    id: 2,
    paymentNo: "PAY-2026-0014",
    invoiceNo: "INV-2026-0002",
    paymentDate: "2026-03-18",
    residentName: "สุดา รุ่งเรือง",
    unitCode: "A-102",
    building: "อาคาร A",
    amount: 900,
    method: "cash",
    status: "partial",
    receiptNo: "RC-2026-0014",
    recordedBy: "Finance 02",
    referenceNo: "-",
    bankName: "-",
    verifiedBy: "Finance Supervisor",
    verifiedAt: "2026-03-18 11:05",
    note: "รับชำระบางส่วน",
  },
  {
    id: 3,
    paymentNo: "PAY-2026-0001",
    invoiceNo: "INV-2026-0003",
    paymentDate: "2026-02-05",
    residentName: "นที วรากร",
    unitCode: "B-203",
    building: "อาคาร B",
    amount: 1800,
    method: "bank_transfer",
    status: "partial",
    receiptNo: "RC-2026-0001",
    recordedBy: "Finance 01",
    referenceNo: "TXN-12000990",
    bankName: "SCB",
    verifiedBy: "Finance Supervisor",
    verifiedAt: "2026-02-05 16:10",
    note: "ตัดชำระบางส่วนของยอดค้างเดิม",
  },
  {
    id: 4,
    paymentNo: "PAY-2026-0021",
    invoiceNo: "INV-2026-0004",
    paymentDate: "2026-03-27",
    residentName: "อรทัย พงศ์พันธ์",
    unitCode: "C-305",
    building: "อาคาร C",
    amount: 2200,
    method: "qr_payment",
    status: "completed",
    receiptNo: "RC-2026-0021",
    recordedBy: "Finance 01",
    referenceNo: "QR-77331209",
    bankName: "PromptPay",
    verifiedBy: "Finance Supervisor",
    verifiedAt: "2026-03-27 10:42",
    note: "ชำระผ่าน QR Payment",
  },
  {
    id: 5,
    paymentNo: "PAY-2026-0022",
    invoiceNo: "INV-2026-0005",
    paymentDate: "2026-03-30",
    residentName: "ปกรณ์ ศิริชัย",
    unitCode: "D-110",
    building: "อาคาร D",
    amount: 2800,
    method: "bank_transfer",
    status: "completed",
    receiptNo: "RC-2026-0022",
    recordedBy: "Finance 01",
    referenceNo: "TXN-88127344",
    bankName: "Bangkok Bank",
    verifiedBy: "Finance Supervisor",
    verifiedAt: "2026-03-30 15:00",
    note: "ชำระผ่าน mobile banking",
  },
  {
    id: 6,
    paymentNo: "PAY-2026-0018",
    invoiceNo: "INV-2026-0007",
    paymentDate: "2026-03-12",
    residentName: "พรทิพย์ สกุลดี",
    unitCode: "G-109",
    building: "อาคาร G",
    amount: 1400,
    method: "qr_payment",
    status: "partial",
    receiptNo: "RC-2026-0018",
    recordedBy: "Finance 02",
    referenceNo: "QR-66778119",
    bankName: "PromptPay",
    verifiedBy: "Finance Supervisor",
    verifiedAt: "2026-03-12 13:55",
    note: "ชำระบางส่วน พร้อมแนบสลิป",
  },
  {
    id: 7,
    paymentNo: "PAY-2026-0030",
    invoiceNo: "INV-2026-0008",
    paymentDate: "2026-04-02",
    residentName: "ชัยวัฒน์ ทองสุข",
    unitCode: "H-501",
    building: "อาคาร H",
    amount: 500,
    method: "cash",
    status: "pending_verify",
    receiptNo: "-",
    recordedBy: "Finance 02",
    referenceNo: "-",
    bankName: "-",
    verifiedBy: "-",
    verifiedAt: "-",
    note: "รอตรวจสอบหลักฐานการชำระเพิ่ม",
  },
  {
    id: 8,
    paymentNo: "PAY-2026-0031",
    invoiceNo: "INV-2026-0009",
    paymentDate: "2026-04-03",
    residentName: "กิตติภพ สุขใจ",
    unitCode: "J-120",
    building: "อาคาร J",
    amount: 2850,
    method: "credit_card",
    status: "completed",
    receiptNo: "RC-2026-0031",
    recordedBy: "Finance 01",
    referenceNo: "CC-99270018",
    bankName: "KTC",
    verifiedBy: "Finance Supervisor",
    verifiedAt: "2026-04-03 09:20",
    note: "ชำระเต็มจำนวนล่วงหน้า",
  },
];

const paymentEvents = {
  1: [
    {
      id: 1,
      time: "2026-03-29 14:05",
      title: "สร้างรายการรับชำระ",
      description: "บันทึกรายการโดย Finance 01",
    },
    {
      id: 2,
      time: "2026-03-29 14:30",
      title: "ตรวจสอบสำเร็จ",
      description: "ตรวจสอบสลิปและยืนยันรายการ",
    },
    {
      id: 3,
      time: "2026-03-29 14:31",
      title: "ออกใบเสร็จ",
      description: "สร้างใบเสร็จเลขที่ RC-2026-0011",
    },
  ],
  2: [
    {
      id: 1,
      time: "2026-03-18 10:50",
      title: "รับชำระเงินสด",
      description: "รับชำระบางส่วนจากลูกบ้าน",
    },
    {
      id: 2,
      time: "2026-03-18 11:05",
      title: "ยืนยันรายการ",
      description: "อนุมัติและออกใบเสร็จรับเงิน",
    },
  ],
  7: [
    {
      id: 1,
      time: "2026-04-02 16:00",
      title: "สร้างรายการรับชำระ",
      description: "บันทึกรายการโดย Finance 02",
    },
    {
      id: 2,
      time: "2026-04-02 16:15",
      title: "รอตรวจสอบ",
      description: "ยังไม่มีข้อมูลอ้างอิงใบเสร็จ รอยืนยันเพิ่มเติม",
    },
  ],
};

const pendingInvoices = [
  {
    id: 101,
    invoiceNo: "INV-2026-0002",
    residentName: "สุดา รุ่งเรือง",
    unitCode: "A-102",
    building: "อาคาร A",
    billingMonth: "มีนาคม 2026",
    totalAmount: 1800,
    paidAmount: 900,
    outstandingAmount: 900,
    dueDate: "2026-03-31",
    status: "partial",
  },
  {
    id: 102,
    invoiceNo: "INV-2026-0003",
    residentName: "นที วรากร",
    unitCode: "B-203",
    building: "อาคาร B",
    billingMonth: "กุมภาพันธ์ 2026",
    totalAmount: 3200,
    paidAmount: 0,
    outstandingAmount: 3200,
    dueDate: "2026-02-28",
    status: "overdue",
  },
  {
    id: 103,
    invoiceNo: "INV-2026-0006",
    residentName: "จิราพร บุญมี",
    unitCode: "E-402",
    building: "อาคาร E",
    billingMonth: "มีนาคม 2026",
    totalAmount: 2500,
    paidAmount: 0,
    outstandingAmount: 2500,
    dueDate: "2026-03-31",
    status: "overdue",
  },
  {
    id: 104,
    invoiceNo: "INV-2026-0007",
    residentName: "พรทิพย์ สกุลดี",
    unitCode: "G-109",
    building: "อาคาร G",
    billingMonth: "มีนาคม 2026",
    totalAmount: 2600,
    paidAmount: 1400,
    outstandingAmount: 1200,
    dueDate: "2026-03-31",
    status: "partial",
  },
  {
    id: 105,
    invoiceNo: "INV-2026-0008",
    residentName: "ชัยวัฒน์ ทองสุข",
    unitCode: "H-501",
    building: "อาคาร H",
    billingMonth: "มีนาคม 2026",
    totalAmount: 5000,
    paidAmount: 0,
    outstandingAmount: 5000,
    dueDate: "2026-03-31",
    status: "overdue",
  },
  {
    id: 106,
    invoiceNo: "INV-2026-0010",
    residentName: "วสันต์ เกียรติยศ",
    unitCode: "F-208",
    building: "อาคาร F",
    billingMonth: "เมษายน 2026",
    totalAmount: 4100,
    paidAmount: 0,
    outstandingAmount: 4100,
    dueDate: "2026-04-30",
    status: "pending",
  },
];

const paymentMethods = [
  { label: "เงินสด", value: "cash", icon: "bi-cash" },
  { label: "โอนธนาคาร", value: "bank_transfer", icon: "bi-bank" },
  { label: "QR Payment", value: "qr_payment", icon: "bi-qr-code" },
  { label: "บัตรเครดิต", value: "credit_card", icon: "bi-credit-card" },
];

export const usePaymentStore = defineStore("payment", {
  state: () => ({
    filters: {
      search: "",
      method: "",
      status: "",
    },
    payments,
    paymentEvents,
    pendingInvoices,
    paymentMethods,
    submitting: false,
  }),

  getters: {
    filteredPayments: (state) => {
      const keyword = state.filters.search.trim().toLowerCase();

      return state.payments.filter((payment) => {
        const searchable = [
          payment.paymentNo,
          payment.invoiceNo,
          payment.residentName,
          payment.unitCode,
          payment.building,
          payment.receiptNo,
          payment.recordedBy,
        ]
          .join(" ")
          .toLowerCase();

        const matchesSearch = !keyword || searchable.includes(keyword);
        const matchesMethod =
          !state.filters.method || payment.method === state.filters.method;
        const matchesStatus =
          !state.filters.status || payment.status === state.filters.status;

        return matchesSearch && matchesMethod && matchesStatus;
      });
    },

    totalPayments: (state) => state.payments.length,
    completedPayments: (state) =>
      state.payments.filter((item) => item.status === "completed").length,
    partialPayments: (state) =>
      state.payments.filter((item) => item.status === "partial").length,
    pendingVerifyPayments: (state) =>
      state.payments.filter((item) => item.status === "pending_verify").length,
    totalCollected: (state) =>
      state.payments.reduce((sum, item) => sum + item.amount, 0),

    methodOptions: () => [
      { label: "ทั้งหมด", value: "" },
      { label: "เงินสด", value: "cash" },
      { label: "โอนธนาคาร", value: "bank_transfer" },
      { label: "QR Payment", value: "qr_payment" },
      { label: "บัตรเครดิต", value: "credit_card" },
    ],

    statusOptions: () => [
      { label: "ทั้งหมด", value: "" },
      { label: "รับชำระสมบูรณ์", value: "completed" },
      { label: "ชำระบางส่วน", value: "partial" },
      { label: "รอตรวจสอบ", value: "pending_verify" },
    ],

    paymentFormInvoiceOptions: (state) =>
      state.pendingInvoices.map((item) => ({
        label: `${item.invoiceNo} • ${
          item.residentName
        } • คงเหลือ ${new Intl.NumberFormat("th-TH", {
          style: "currency",
          currency: "THB",
          minimumFractionDigits: 0,
        }).format(item.outstandingAmount)}`,
        value: item.invoiceNo,
      })),

    getPaymentById: (state) => (id) =>
      state.payments.find((item) => item.id === Number(id)) || null,
    getEventsByPaymentId: (state) => (id) =>
      state.paymentEvents[Number(id)] || [],
    getInvoiceByNo: (state) => (invoiceNo) =>
      state.pendingInvoices.find((item) => item.invoiceNo === invoiceNo) ||
      null,
  },

  actions: {
    setSearch(value) {
      this.filters.search = value;
    },
    setMethod(value) {
      this.filters.method = value;
    },
    setStatus(value) {
      this.filters.status = value;
    },
    resetFilters() {
      this.filters.search = "";
      this.filters.method = "";
      this.filters.status = "";
    },

    async createPayment(payload) {
      this.submitting = true;
      await new Promise((resolve) => setTimeout(resolve, 700));

      const nextId = this.payments.length
        ? Math.max(...this.payments.map((item) => item.id)) + 1
        : 1;
      const nextRunning = String(nextId).padStart(4, "0");
      const now = new Date();
      const paymentNo = `PAY-${now.getFullYear()}-${nextRunning}`;
      const receiptNo = payload.generateReceipt
        ? `RC-${now.getFullYear()}-${nextRunning}`
        : "-";

      const invoice = this.getInvoiceByNo(payload.invoiceNo);
      const newPayment = {
        id: nextId,
        paymentNo,
        invoiceNo: payload.invoiceNo,
        paymentDate: payload.paymentDate,
        residentName: invoice?.residentName || "-",
        unitCode: invoice?.unitCode || "-",
        building: invoice?.building || "-",
        amount: Number(payload.amount || 0),
        method: payload.method,
        status: payload.status,
        receiptNo,
        recordedBy: "Current User",
        referenceNo: payload.referenceNo || "-",
        bankName: payload.bankName || "-",
        verifiedBy:
          payload.status === "pending_verify" ? "-" : "Finance Supervisor",
        verifiedAt:
          payload.status === "pending_verify"
            ? "-"
            : `${payload.paymentDate} 15:00`,
        note: payload.note || "",
      };

      this.payments.unshift(newPayment);
      this.paymentEvents[nextId] = [
        {
          id: 1,
          time: `${payload.paymentDate} 14:45`,
          title: "สร้างรายการรับชำระ",
          description: "สร้างรายการจากหน้าฟอร์มรับชำระเงิน",
        },
      ];

      this.submitting = false;
      return { success: true, id: nextId };
    },
    updatePayment(payload) {
      const index = this.payments.findIndex((p) => p.id === payload.id);
      if (index === -1) return;

      const prev = this.payments[index];

      this.payments[index] = {
        ...prev,
        paymentDate: payload.paymentDate,
        amount: Number(payload.amount),
        method: payload.method,
        bankName: payload.bankName || "-",
        referenceNo: payload.referenceNo || "-",
        status: payload.status,
        receiptNo: payload.receiptNo || "-",
        note: payload.note || "",
        // อัปเดต verifiedBy/verifiedAt ตามสถานะใหม่
        verifiedBy:
          payload.status === "pending_verify"
            ? "-"
            : prev.verifiedBy !== "-"
            ? prev.verifiedBy
            : "Finance Supervisor",
        verifiedAt:
          payload.status === "pending_verify"
            ? "-"
            : prev.verifiedAt !== "-"
            ? prev.verifiedAt
            : `${payload.paymentDate} 15:00`,
      };

      // เพิ่ม timeline event ว่ามีการแก้ไข
      const events = this.paymentEvents[payload.id] || [];
      const now = new Date();
      const timeStr = `${now.getFullYear()}-${String(
        now.getMonth() + 1,
      ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")} ${String(
        now.getHours(),
      ).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;

      this.paymentEvents[payload.id] = [
        ...events,
        {
          id: events.length + 1,
          time: timeStr,
          title: "แก้ไขรายการรับชำระ",
          description: `แก้ไขข้อมูลโดย Current User — สถานะ: ${payload.status}`,
        },
      ];
    },
  },
});
